// ================ Action types ================ //

export const LOCATION_CHANGED = 'app/routing/LOCATION_CHANGED';

// ================ Reducer ================ //

const initialState = {
  currentLocation: null,
  currentCanonicalPath: null,
  previousCanonicalPath: null,
};

export default function routingReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case LOCATION_CHANGED:
      return {
        ...state,
        currentLocation: payload.location,
        previousCanonicalPath: state.currentCanonicalPath,
        currentCanonicalPath: payload.canonicalPath,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const locationChanged = (location, canonicalPath) => ({
  type: LOCATION_CHANGED,
  payload: { location, canonicalPath },
});
